<template>
    <div class="profile-view">
        <!-- Header -->
        <HeaderComponent />

        <!-- Profile Navigation Bar -->
        <nav class="profile-navigation">
            <div class="container">
                <div class="d-flex justify-content-between align-items-center">
                    <button @click="goBack" class="btn-back">
                        &lt; zurück
                    </button>
                    <ul class="profile-nav-tabs">
                        <li v-for="tab in tabs" :key="tab.id" class="nav-item"
                            :class="{ active: activeSection === tab.id }">
                            <a href="#" class="nav-link" :class="{ active: activeSection === tab.id }"
                                @click.prevent="handleNavigation(tab.id)">
                                {{ tab.label }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>

        <!-- Profile Content -->
        <main class="profile-content">
            <div class="container">
                        <!-- Politik Section -->
                        <section id="politik" ref="politikSection" class="profile-section">
                            <!-- Profile Hero - Desktop layout like main page -->
                            <div class="profile-hero-content">
                                <div class="profile-image">
                                    <img src="/images/sylvia-braun-2.jpg" alt="Sylvia Braun" class="hero-image">
                                </div>
                                
                                <div class="profile-text">
                                    <h1 class="section-title">Politik</h1>
                                    <h2 class="section-subtitle">Quereinsteigerin, Ehrenamt, Beruf</h2>
                                    <div class="section-content">
                                <p>
                                    Politisch aktiv wurde ich erst spät – aber mit voller Überzeugung. Nach der Geburt
                                    meiner Kinder war ich zum ersten Mal spürbar auf meine Kommune angewiesen – und
                                    entdeckte schnell strukturelle Defizite, die mich nicht losließen. Ich begann, mich
                                    über die Elternbeteiligung einzubringen, initiierte einen Kita-Förderverein und
                                    unterstützte die Weiterentwicklung der Brückenschule zur Ganztagsschule.
                                </p>
                                <p>
                                    Dabei wurde mir deutlich: Kommunen sind der Ort, an dem die Weichen gestellt werden.
                                    Ich wollte den Betroffenen eine Stimme geben – und kandidierte für die
                                    Stadtverordnetenversammlung.

                                </p>
                                <p>
                                    2011 rückte ich für die FDP ins Bruchköbeler Parlament nach, 2012 wurde ich
                                    Fraktionsvorsitzende. Als Spitzenkandidatin 2016 führte ich eine gestärkte Fraktion
                                    in die nächste Legislatur.

                                </p>
                                <p>
                                    2019 bewarb ich mich um das Bürgermeisteramt. Im ersten Wahlgang konnte ich mich mit
                                    knapp 30% gegen sechs Mitbewerber durchsetzen, im zweiten Wahlgang erreichte ich
                                    knapp 70% der Stimmen. Seit April 2020 bin ich Ihre Bürgermeisterin von Bruchköbel.

                                </p>
                                <p>
                                    Mein politisches Handeln folgt einem klaren Leitsatz:
                                </p>
                                <p>
                                    Parteipolitik hat in der Kommune keinen Platz.
                                    Ich bin nicht die Bürgermeisterin einer Partei, sondern möchte ein Angebot für alle
                                    Bruchköbelerinnen und Bruchköbeler sein. Für mich steht unsere Stadt an erster
                                    Stelle – pragmatische Lösungen statt Ideologie.

                                </p>
                                <p>
                                    Dafür trete ich auch in der kommenden Amtszeit wieder an.
                                </p>
                                <p></p>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <!-- Beruf Section -->
                        <section id="beruf" ref="berufSection" class="profile-section split-layout">
                            <div class="section-left">
                                <h1 class="section-title">Werdegang</h1>
                                <h2 class="section-subtitle">Polizistin. Pionierin. Bürgermeisterin.</h2>
                            </div>
                            <div class="section-right">
                                <div class="section-content">
                                <p> <br>
                                    Als ich mich Ende der 80er Jahre für eine Ausbildung bei der Hessischen Polizei
                                    entschieden habe, waren Frauen im Polizeidienst noch selten, und auf mehreren
                                    Dienststellen war ich oft die erste Frau in Uniform – eine Rolle, die mich forderte
                                    und prägte.
                                </p>
                                <p>
                                    Ich lernte früh, schnell Entscheidungen zu treffen, sie durchzusetzen und
                                    Verantwortung zu übernehmen. Nach mehreren Jahren im Streifendienst, unter anderem
                                    bei der Autobahnpolizei und in der Hanauer Innenstadt, qualifizierte ich mich für
                                    ein Studium an der Verwaltungsfachhochschule.
                                </p>
                                <p>
                                    Nach zweieinhalb Jahren Vollzeit-Studium schloss ich im Jahr 2000 erfolgreich als
                                    Diplom-Verwaltungswirtin ab. Das Studium öffnete mir neue Perspektiven: Ich
                                    wechselte von der Schutz- zur Kriminalpolizei und arbeitete bald im damals noch
                                    neuen Feld der Internetermittlungen – wieder mit viel Pionierarbeit.

                                </p>
                                <p>
                                    Mit der Geburt meiner Söhne reduzierte ich für ein paar Jahre meine Arbeitszeit und
                                    lernte die Herausforderungen der Vereinbarkeit von Familie und Beruf kennen – und zu
                                    schätzen, was Homeoffice ermöglichen kann. Später wechselte ich in die Digitale
                                    Forensik und übernahm ich den Aufbau und die Leitung einer neuen Abteilung im
                                    Bereich Mobilgeräteforensik.

                                </p>
                                <p>
                                    Seit meinem Amtsantritt als Bürgermeisterin im April 2020 ruht mein Beamtenstatus
                                    bei der Hessischen Polizei.
                                </p>
                                </div>
                            </div>
                        </section>

                        <!-- Privat Section -->
                        <section id="privat" ref="privatSection" class="profile-section split-layout">
                            <div class="section-left">
                                <h1 class="section-title">Privat</h1>
                                <h2 class="section-subtitle">Familie, Bewegung, gutes Essen – mein Ausgleich</h2>
                            </div>
                            <div class="section-right">
                                <div class="section-content">
                                <p> <br>
                                    Ich habe zwei Söhne, die mittlerweile junge Erwachsene sind. Wir leben in
                                    Bruchköbel-Roßdorf, aufgewachsen bin ich in Gründau-Lieblos, dort lebt auch meine
                                    Mutter.
                                </p>
                                <p>
                                    In meiner Freizeit halte ich mich mit Radfahren fit, gerne ganz früh am Morgen rund
                                    um Bruchköbel auf meinem Gravelbike, das macht den Kopf frei. Gutes und gesundes
                                    Essen muss sich nicht widersprechen, dafür koche ich am liebsten selbst.
                                </p>
                                </div>
                            </div>
                        </section>
            </div>
        </main>

        <!-- Footer -->
        <FooterComponent />
    </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
    name: 'ProfileView',
    components: {
        HeaderComponent,
        FooterComponent
    },
    data() {
        return {
            activeSection: 'politik',
            tabs: [
                { id: 'politik', label: 'Politik' },
                { id: 'beruf', label: 'Beruf' },
                { id: 'privat', label: 'Privat' }
            ],
            sections: ['politik', 'beruf', 'privat']
        }
    },
    mounted() {
        this.handleScroll()
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        handleScroll() {
            // Check visibility of section titles
            const sectionTitles = [
                { id: 'politik', title: 'Politik', element: this.$refs.politikSection?.querySelector('.section-title') },
                { id: 'beruf', title: 'Werdegang', element: this.$refs.berufSection?.querySelector('.section-title') },
                { id: 'privat', title: 'Privat', element: this.$refs.privatSection?.querySelector('.section-title') }
            ]

            let currentSection = 'politik' // Default
            const windowHeight = window.innerHeight
            
            // Check which section titles are visible
            const visibleTitles = sectionTitles.filter(section => {
                if (!section.element) return false
                
                const rect = section.element.getBoundingClientRect()
                // Title is considered visible if it's in the viewport
                return rect.top >= 0 && rect.top <= windowHeight
            })
            
            // If only one title is visible, use that section
            if (visibleTitles.length === 1) {
                currentSection = visibleTitles[0].id
            } else if (visibleTitles.length > 1) {
                // If multiple titles are visible, use the topmost one
                currentSection = visibleTitles[0].id
            } else {
                // If no titles are visible, check which sections are in view
                for (let i = 0; i < sectionTitles.length; i++) {
                    const section = sectionTitles[i]
                    if (section.element) {
                        const sectionElement = section.element.closest('.profile-section')
                        if (sectionElement) {
                            const rect = sectionElement.getBoundingClientRect()
                            // If section content is visible
                            if (rect.top < windowHeight && rect.bottom > 0) {
                                currentSection = section.id
                                break
                            }
                        }
                    }
                }
            }

            this.activeSection = currentSection
        },
        handleNavigation(sectionId) {
            const element = document.getElementById(sectionId)
            if (element) {
                const navigationHeight = 120 // Account for navigation height
                const elementPosition = element.offsetTop - navigationHeight

                window.scrollTo({
                    top: elementPosition,
                    behavior: 'smooth'
                })
            }
        },
        goBack() {
            this.$router.push('/')
        }
    }
}
</script>